import { IDictionary } from "@common/models";
import { IAppConfig } from "@config/appConfig";


const Config = () => { };

const storage: IDictionary<any> = {};

const config: IAppConfig = {} as IAppConfig;

Config.getConfig = (): IAppConfig => {
    return Config.config;
}

Config.init = (config: IAppConfig) => {
    Config.config = config;
}

Config.set = <T>(key: string, value: T) => {
    Config.config[key] = value;
}

Config.get = <T>(key: string, defaultValue?: T) => {
    if (key in Config.storage) {
        return Config.storage[key];
    }
    if (key in Config.config) {
        return Config.config[key as keyof IAppConfig];;
    }
    return defaultValue;
}

Config.storage = storage;
Config.config = config;

export default Config;
